export default __webpack_public_path__ + "static/media/brighthive-logo-large.12578e24.svg";